const {Component} = require("react");
const PropTypes = require("prop-types");
const $ = require("helpers/element");

class BurgerTrigger extends Component {

	static get propTypes() {
		return {
			targetSelector: PropTypes.string.isRequired,
			targetClassName: PropTypes.string.isRequired
		};
	}

	get targetStatus() {
		const element = document.querySelector(this.props.targetSelector);

		if (element == undefined) {
			return false;
		}

		return $(element).hasClass(this.props.targetClassName);
	}

	updateTarget(status = true) {
		const element = document.querySelector(this.props.targetSelector);

		if (element == undefined) {
			return;
		}

		$(element).setClass(this.props.targetClassName, status);
	}

	_onClick = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.updateTarget(!this.targetStatus);
	};

	render() {
		return (
			<div className="burger" onClick={this._onClick}>
				<div className="line"></div>
				<div className="line"></div>
				<div className="line"></div>
			</div>
		);
	}

}

module.exports = BurgerTrigger;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/BurgerTrigger.js